import axios from 'redaxios'
import Swal from 'sweetalert2'
const url = 'https://bodework-backend.herokuapp.com/api/'

export const login = async (endpoint, body) => {
  try {
    localStorage.setItem('isLoading', JSON.stringify(true))
    let response = await axios.post(`${url}${endpoint}`, body)
    localStorage.setItem('isLoading', JSON.stringify(false))
    return response.data
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: error.message,
      text: 'Please try again!',
      timer: 3000,
      confirmButtonColor: '#2597F6',
    })
  }
}

export const registerUser = async (endpoint, body) => {
  try {
    localStorage.setItem('isLoading', JSON.stringify(true))
    let response = await axios.post(`${url}${endpoint}`, body, {
      headers: { Accept: 'application/json' },
    })
    localStorage.setItem('isLoading', JSON.stringify(false))
    return response
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: error.data.message,
      text: 'Please try again!',
      timer: 3000,
      confirmButtonColor: '#2597F6',
    })
  }
}

export const switchProfile = async (endpoint, body) => {
  try {
    localStorage.setItem('isLoading', JSON.stringify(true))
    let response = await axios.post(`${url}${endpoint}`, body)
    localStorage.setItem('isLoading', JSON.stringify(false))
    return response.data
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: error.message,
      text: 'Please try again!',
      timer: 3000,
      confirmButtonColor: '#2597F6',
    })
  }
}
